<ng-container *ngIf="!(isLoading$ | async)">
    <router-outlet></router-outlet>
</ng-container>